import { cn } from '@r/utils/utils.ts';
import type { HTMLAttributes } from 'react';

type SkeletonProps = HTMLAttributes<HTMLDivElement> & {
  breathe?: boolean;
};

function Skeleton({ className, breathe = true, ...props }: SkeletonProps) {
  return (
    <div
      className={cn('rounded-md bg-muted', breathe ? 'animate-pulse' : '', className)}
      {...props}
    />
  );
}

export { Skeleton };
